export function unixToTicks(unix) {
  return (unix * 10000) + 621355968000000000;
}